<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="selectedOutcome ? false : true"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center" style="position: relative">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "Outcome Plan For "
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :label="`${outcome ? '' : 'Click Here'}`"
            :model="outcome"
            class="q-ml-sm"
            :style="`min-width: 230px;
                    max-width: 500px;
                      background-color: ${cssVars['--outcome-secondary']};
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            @input="selectOutcome"
          ></sustainability-dropdown>
          <span v-if="outcome" class="headerText text-white q-mx-sm">
            for
          </span>
          <year-picker
            v-if="outcome"
            ref="yearPicker"
            label=""
            :bg="cssVars['--outcome-secondary']"
            @selectYear="selectYear"
          ></year-picker>
          <q-img
            v-if="selectedOutcome"
            class="float-right"
            :src="getWhiteOutcomeImage(selectedOutcome)"
            style="position: absolute; right: 15px; width: 69px; top: -20px"
          ></q-img>
        </div>
      </template>
      <template v-slot:content>
        <div class="column">
          <div class="col-auto" style="height: calc(100vh - 226px)">
            <div
              class="row content q-px-md q-gutter-x-lg"
              v-if="selectedOutcome"
            >
              <div class="col q-px-sm q-py-lg">
                <div style="max-width: 400px; margin: auto">
                  <h4 style="font-weight: 800">
                    {{
                      outcomeDescriptions()[selectedOutcome.name].Explanation
                        .title
                    }}
                  </h4>
                  <div
                    v-html="
                      outcomeDescriptions()[selectedOutcome.name].Explanation
                        .html
                    "
                  ></div>
                </div>
              </div>
              <div class="col q-px-sm q-py-lg">
                <div style="max-width: 400px; margin: auto">
                  <h4 style="font-weight: 800">
                    {{ outcomeDescriptions()[selectedOutcome.name].Goal.title }}
                  </h4>
                  <div
                    v-html="
                      outcomeDescriptions()[selectedOutcome.name].Goal.html
                    "
                  ></div>
                </div>
              </div>
              <div class="col q-px-sm q-py-lg">
                <div style="max-width: 400px; margin: auto">
                  <h4 style="font-weight: 800">
                    {{
                      outcomeDescriptions()[selectedOutcome.name].Examples.title
                    }}
                  </h4>
                  <div
                    v-html="
                      outcomeDescriptions()[selectedOutcome.name].Examples.html
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col q-px-md">
            <q-btn
              class="q-px-sm q-py-xs bg-secondary"
              label="Back to Dashboard"
              text-color="white"
              color="secondary"
              no-caps
              flat
              @click="$router.push('/')"
            >
            </q-btn>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div class="column full-height full-width sidebar">
          <div class="col-auto q-px-lg q-py-md" style="height: 109px">
            <div class="row full-height items-center">
              <div class="col-12">
                <h3>The Steps of this Plan</h3>
              </div>
            </div>
          </div>
          <div class="col-auto q-px-lg" style="height: calc(100vh - 226px)">
            <div>
              <h5>#1 Where are you today?</h5>
              <h5>#2 Where do you want to be?</h5>
              <h5>#3 How are you going to get there?</h5>
              <h5>#4 Complete your Full Plan</h5>
              <h5>#5 Take Action, how did you go?</h5>
            </div>
          </div>
          <div class="col q-px-md">
            <q-btn
              class="q-px-sm q-py-xs bg-accent float-right"
              :label="
                outcomePlan && outcomePlan.currentStep
                  ? 'Continue Plan'
                  : 'Start Plan'
              "
              text-color="white"
              color="accent2"
              no-caps
              flat
              @click="$router.push(`${$route.path}/chooseAssessmentTool`)"
            >
            </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import YearPicker from "@/components/generalComponents/yearPicker.vue";
  import PageLayout from "@/components/pageLayout/pageLayout.vue";
  import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
  import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";
  import { outcomeDescriptions } from "@/functions/outcomeDescriptions";

  export default {
    components: {
      YearPicker,
      PageLayout,
      SustainabilityDropdown,
    },
    async mounted() {
      if (this.selectedOutcome) {
        this.initSelectedOutcome();
      }
    },
    data: () => ({
      outcome: null,
    }),
    watch: {
      selectedOutcome: function () {
        this.initSelectedOutcome();
      },
    },
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        currentUserData: "auth/currentUserData",
        outcomePlan: "businessOutcomePlans/current",
        outcomePlanLoading: "businessOutcomePlans/currentLoading",
        selectedOutcome: "businessOutcomePlans/selectedOutcome",
      }),
      cssVars() {
        let primaryColorFaded = this.selectedOutcome
          ? this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor.split("#")
            : ["", "162c47"]
          : "#162c47";
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
        if (this.selectedOutcome) {
          return {
            "--outcome-primary": this.selectedOutcome.primaryColor
              ? this.selectedOutcome.primaryColor
              : "#162c47",
            "--outcome-secondary": this.selectedOutcome.secondaryColor
              ? this.selectedOutcome.secondaryColor
              : "#162c47",
            "--outcome-tertiary": this.selectedOutcome.tertiaryColor
              ? this.selectedOutcome.tertiaryColor
              : "#162c47",
            "--outcome-primary-faded": primaryColorFadedString,
          };
        } else {
          return {
            "--outcome-primary": "#162c47",
            "--outcome-secondary": "white",
            "--outcome-tertiary": "#162c47",
            "--outcome-primary-faded": "#162c47",
          };
        }
      },
    },
    methods: {
      getWhiteOutcomeImage: getWhiteOutcomeImage,
      initSelectedOutcome() {
        this.outcome = this.selectedOutcome;
      },
      selectOutcome(outcome) {
        this.$router.push(`/outcomePlans/outcome/${outcome.id}`);
      },
      outcomeDescriptions: outcomeDescriptions,

      selectYear(val) {
        this.selectedYear = val.split("/")[0];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sidebar {
    h3 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 1.3rem;
      line-height: 29px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }

    h4 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 1.1rem;
      line-height: 2rem;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }

    h5 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      line-height: 2rem;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }
  }

  .content {
    h4 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 600;
      font-size: 1.2rem;
      line-height: 24px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }
  }

  .headerText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
  }

  .questionTitle {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
  }

  .button-bg {
    background-color: var(--outcome-secondary);
  }

  .button-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 11.6054px;
  }
</style>
